import React from 'react'
import ReactPlayer, { ReactPlayerProps } from 'react-player'

interface VideoScreenSaverProps {
  url: string
}
type VideoPlayerProps = Required<NonNullable<ReactPlayerProps>>

const VOLUME: VideoPlayerProps['volume'] = 0
const STYLE: VideoPlayerProps['style'] = {
  backgroundColor: '#000000',
}

function VideoScreenSaver({ url }: VideoScreenSaverProps) {
  const [isReady, setIsReady] = React.useState(false)

  const handleToggleReadyStatus = React.useCallback(
    (status: boolean) => () => setIsReady(status),
    []
  )

  return (
    <div className={`absolute inset-0 z-[99999] ${!isReady ? 'hidden' : ''}`}>
      <ReactPlayer
        style={STYLE}
        url={url}
        playing
        width="100%"
        height="100%"
        volume={VOLUME}
        loop
        onReady={handleToggleReadyStatus(true)}
        onError={handleToggleReadyStatus(false)}
      />
    </div>
  )
}

export default VideoScreenSaver
